import type { ComposantEcran } from '../../app/ecrans.js';
import { EcranM04, EcranM07, EcranX13, EcranX14 } from './conteneurs.js';

/**
 * Écrans fournis par le lot L61 au registre de la coquille : M04 (empreinte et action unique), M07 (confidentialité),
 * X13 (portail du mandant) et X14 (portail de l'héritier). M05, M06 et X15 appartiennent à d'autres lots.
 */
export const ecrans: Record<string, ComposantEcran> = { M04: EcranM04, M07: EcranM07, X13: EcranX13, X14: EcranX14 };

export { EcranM04, EcranM07, EcranX13, EcranX14, type DependancesPortail } from './conteneurs.js';
export { creerSource, ROUTES_DU_PORTAIL, type SourcePortail } from './source.js';
export { projeterAccueil, resumeProgression, choixConfidentialite, corpsModification } from './modele.js';
